import React, { useEffect, useState } from "react";
import api from "api";
import Swal from "sweetalert2";
import { useTranslation } from 'react-i18next';
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { useNavigate } from 'react-router-dom'
import StripePaymentForm from "components/stripe/StripePaymentForm"; // ton composant Stripe générique

export default function OrderPaymentModal({
  orderId,
  onClose,
  onPaid
}) {
  const [loading, setLoading] = useState(true);
  const [paymentData, setPaymentData] = useState(null);
  const [stripePromise, setStripePromise] = useState(null);
  const navigate = useNavigate();
  // -------------------------------
  // Charger paymentData automatiquement
  // -------------------------------
  useEffect(() => {
    const loadPaymentData = async () => {
      setLoading(true);
      setPaymentData(null);
      try {
        const res = await api.get(`/orders/${orderId}/paymentData`);

        if (!res?.data?.clientSecret) {
          throw new Error("paymentData manquant");
        }
        setPaymentData(res.data);
        setStripePromise(loadStripe(res.data.publicKey));
      } catch (e) {
        console.error("PAYMENTDATA ERROR", e);
        Swal.fire({
          title: "Erreur",
          text: "Impossible de charger les informations de paiement."
        });
        onClose();
      } finally {
        setLoading(false);
      }
    };
    loadPaymentData();
  }, [orderId]);
  // -------------------------------
  // Callback du formulaire Stripe
  // -------------------------------
  const handleStripeResult = async (result) => {

    if (result.status === "error") {
      onClose();
      return;
    }
    // 🏦 SEPA
    if (result.status === "processing") {
      Swal.fire({
        title: "Virement initié",
        text: "Votre virement a bien été pris en compte. Le paiement sera confirmé sous quelques jours.",
        icon: undefined
      });
      onClose();
      return;
    }
    // 💳 CB
    if (result.status === "succeeded") {
      Swal.fire({
        title: "Validation du paiement…",
        text: "Veuillez patienter quelques instants.",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading()
      });
      await new Promise(resolve => setTimeout(resolve, 3000));
      try {
        const res = await api.get(`/order/${orderId}/checkPayment`);
        Swal.fire({

          title: "Paiement confirmé",
          text: "Votre demande de formalité va maintenant être traitée."
        });
        onPaid && onPaid(res.data);
      } catch {
        Swal.fire({

          title: "Paiement confirmé",
          text: "Le paiement est validé, mais la mise à jour est retardée."
        });
        onPaid && onPaid();
        // navigate('/customer/account/orders')
      }
      onClose();
    }
  };
  // -------------------------------
  // Rendu Modal Bootstrap 5
  // -------------------------------
  return (
    <div
      className="modal fade show"
      style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
      tabIndex="-1"
      role="dialog"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          {/* HEADER */}
          <div className="modal-header">
            <div className="modal-title">Paiement sécurisé</div>
            <button type="button" className="btn-close" onClick={onClose} />
          </div>
          {/* BODY */}
          <div className="modal-body">
            {loading && (
              <div className="text-center py-4">
                Chargement des informations de paiement…
              </div>
            )}
            {!loading && paymentData && stripePromise && (
              <>
                <p className="text-muted mb-3">
                  Montant à régler : <strong>{paymentData.orderBalance} €</strong>
                </p>
                <Elements stripe={stripePromise} options={{ clientSecret: paymentData.clientSecret }}>
                  <StripePaymentForm onResult={handleStripeResult} />
                </Elements>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
